<template lang="pug">
  .b-main
    Nodes
</template>

<script>
import Nodes from '@/components/nodes/Nodes.vue';

export default {
  name: 'Home',
  components: {
    Nodes,
  },
};
</script>

<style lang="scss">
  .b-main {
    background: #EDF0F4;
  }
</style>
